import { render } from "./HistoryCustomerPage.vue?vue&type=template&id=3c97e6be&ts=true"
import script from "./HistoryCustomerPage.vue?vue&type=script&lang=ts"
export * from "./HistoryCustomerPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__